import { SkillEnum, SkillModel } from '@/apiTypes/SkillsTypes';
import { createContext } from 'react';
import { CustomSkillData } from '@/pages/LegacySkills/AddCustomSkillForm.tsx';

export interface SkillsContextType {
    stagedSkills: SkillModel[];
    setStagedSkills: (skills: SkillModel[]) => void;
    stagedCustomSkills: CustomSkillData[];
    setStagedCustomSkills: (customSkills: CustomSkillData[]) => void;
    setCreationType: (creationType: 'custom' | 'default' | undefined) => void;
    creationType: 'custom' | 'default' | undefined;
    skillTypesFilter: SkillEnum[];
    setSkillTypesFilter: (skillTypes: SkillEnum[]) => void;
    skillCategoryIdsFilter: string[];
    setSkillCategoryIdsFilter: (categoryIds: string[]) => void;
    occupationIdsFilter: string[];
    setOccupationIdsFilter: (occupationIds: string[]) => void;
}

export const SkillsContext = createContext<SkillsContextType | undefined>(undefined);
